/* eslint-disable camelcase */
/* @flow strict */

import * as React from 'react';
import { convertToLocalTime } from '/client/src/utils/jstz';
import { parseResponse } from '/client/src/pages/Events/detail/listView/helper';


type PropsType = {
    id: number | string,
    image_url: string,
    image_crop_info: any,
    end_time_utc: string,
    begin_time_utc: string,
    status: string,
    name: string,
    location: string,
    time_zone_id: string,
    is_set_tickets_total_capacity: boolean,
    tickets_total_capacity: number,
    schedules: [],
    transactions: any,
    handleEventData: (id: number | string, eventScheduleId: number | string) => void
};

const CheckInEventListItem = ({
    id,
    image_url,
    image_crop_info,
    begin_time_utc,
    end_time_utc,
    status,
    name,
    location,
    time_zone_id,
    is_set_tickets_total_capacity,
    tickets_total_capacity,
    schedules,
    transactions,
    handleEventData
}: PropsType): React.Element<typeof React.Fragment> => {

const x1 = _.get(image_crop_info, 'x1', 0);
const x2 = _.get(image_crop_info, 'x2', 0);
const y1 = _.get(image_crop_info, 'y1', 0);
const y2 = _.get(image_crop_info, 'y2', 0);

const imageUrlParams = `maxwidth=3200&maxheight=3200&crop=(${encodeURIComponent(`${x1},${y1},${x2},${y2}`)})&width=480`;
const isGrayFilterClass = (new Date(end_time_utc).getTime() - new Date().getTime()) < 0 || status === 'Close' || status === 'Archive';

const startTime = begin_time_utc ? convertToLocalTime(begin_time_utc, time_zone_id, 'MMM Do, h:mm A') : '';
const endTime = end_time_utc ? convertToLocalTime(end_time_utc, time_zone_id, 'MMM Do, h:mm A z') : '';

const {
    sold_quantity
  } = parseResponse(transactions, is_set_tickets_total_capacity, tickets_total_capacity);

    return (
        <div className="_row" onClick={(): void => handleEventData(id, _.get(schedules, '[0].id', 0))}>
        {/* eslint-disable-next-line*/}
        <div className="EventCardLine EventCardLine-checkIn">
          <div className="EventCardLine-col EventCardLine-col--img">
            <div className="EventCardLine-dateImg">
              <div className='EventCardLine-dateImg-month'>{convertToLocalTime(begin_time_utc, time_zone_id, 'MMM')}</div>
              <div className='EventCardLine-dateImg-date'>{convertToLocalTime(begin_time_utc, time_zone_id, 'DD')}</div>
            </div>
            <div className="EventCardLine-img" style={{ display: 'none' }}>
              <div
                className="EventCardLine-img-picture"
                style={{
                  backgroundImage: `url("${image_url}?${imageUrlParams}")`
                }}
              />
            </div>
          </div>
          <div className="EventCardLine-col">
          <div className="EventCardLine-dateImg">
            <div className="EventCardLine-dateImg-img-placeholder">
              <div
                className={`EventCardLine-dateImg-img ${isGrayFilterClass ? 'filter--gray' : ''}`}
                style={{
                  backgroundImage: `url("${image_url}?${imageUrlParams}")`
                }}
              />
            </div>
          </div>
        </div>

        <div className="EventCardLine-col">
          <div className="EventCardLine-description">
            <h4>{name}</h4>

            <p>{startTime} - {endTime}</p>
            <p>{location}</p>
          </div>
        </div>
  
          <div className="EventCardLine-stock">
            <p>{sold_quantity ? sold_quantity : '0'} / {transactions.ticket_quantity_expected}</p>
          </div>
        </div>

      </div>
    );
};

export default CheckInEventListItem;
